import React from 'react'

import { Loader, LoaderContainer } from './card-loader'

export const CardLoader = () => (
  <LoaderContainer>
    <Loader />
  </LoaderContainer>
)
